module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/sec05_sp_88581ee2be57ecef266945e9cfbd36c1.jpg";